import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import starightcut1 from "../assests/img/ProductsImages/StraightcutFrenchfries.jpg";
import friescoated from "../assets/img/update_2/normal/friescoated.jpg";
import friesshoestring from "../assests/img/ProductsImages/Shoestringfries1.jpg";

const Frenchfries_comp = () => {
  return (
    <div className="container">
      {/* Product 1 */}
      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={starightcut1}
                alt="Classic French Fries"
                className="smiproductt-img"
              />
            </div>
            <div className="col-md-6">
              <h2 className="smiproductt-title">YUMWAY CLASSIC FRENCH FRIES</h2>
              <h4 className="smiproductt-subtitle">
                Golden. Crispy. Naturally Yours.
              </h4>
              <p className="smiproductt-text">
                Made with real, non-GMO potatoes, our fries are lightly blanched, quick-frozen, and packed for crisp perfection. Designed to suit family snacks, school tiffins, or restaurant plates.
              </p>
              <div className="smiproductt-meta">
                <p>
                  <strong>Available Cuts:</strong> 6-11 mm <br/>
                  <strong>Available In:</strong> 2.5kg | 1kg | Private Label
                </p>                
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 170-180°C | 2.5-3.5 mins</li>
                  <li>Air Fry: 180°C | 10-12 mins</li>
                  <li>Bake: 200°C | 12-15 mins</li>
                  <li>No preservatives</li>
                  <li>Vegetarian & clean-label</li>
                  <li>3-minute crisp solution*</li>
                </ul>
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
          </div>
        </div>
      </section>


      <section className="smiproductt-section">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center flex-md-row-reverse">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={friesshoestring}
                alt="Shoestring French Fries"
                className="smiproductt-img"
              />
            </div>
            <div className="col-md-6">
              <h2 className="smiproductt-title">SHOESTRING FRENCH FRIES</h2>
              <h4 className="smiproductt-subtitle">Xtra Crispy, Xtra Long</h4>
              <p className="smiproductt-text">
                Extra-long, irresistibly delicious, and incredibly crunchy, our Shoestring French Fries feature a uniform cut that ensures generous serving portions every time.
              </p>
              <div className="smiproductt-meta">
                <p>
                  <strong>Available Cuts:</strong> 6-7 mm <br/>
                  <strong>Available In:</strong> 2.5kg | 1kg | Private Label
                </p>                
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 170-180°C | 2.5-3.5 mins</li>
                  <li>Air Fry: 180°C | 10-12 mins</li>
                  <li>Bake: 200°C | 12-15 mins</li>
                  <li>No preservatives</li>
                  <li>Vegetarian & clean-label</li>
                  <li>3-minute crisp solution*</li>
                </ul>
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
          </div>
        </div>
      </section>

      {/* Product 3 */}
      <section className="smiproductt-section mb-5 pb-5">
        <div className="smiproductt-card p-4">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={friescoated}
                alt="Coated Fries"
                className="smiproductt-img"
              />
            </div>
            <div className="col-md-6">
              <h2 className="smiproductt-title">COATED FRIES</h2>
              <h4 className="smiproductt-subtitle">
                Flavoured, Yummy, Truly Yours
              </h4>
              <p className="smiproductt-text">
                Our Coated Fries are crispy, golden, and seasoned to perfection. With a special batter for extra crunch and long hold time, they’re perfect for both delivery and dine-in experiences.
              </p>
              <div className="smiproductt-meta">
                <p>
                  <strong>Available Cuts:</strong> 6-11 mm <br/>
                  <strong>Available In:</strong> 2.5kg | 1kg | Private Label
                </p>                
                <p>
                  <strong>Cooking:</strong>
                </p>
                <ul>
                  <li>Deep Fry: 170-180°C | 2.5-3.5 mins</li>
                  <li>Air Fry: 180°C | 10-12 mins</li>
                  <li>Bake: 200°C | 12-15 mins</li>
                  <li>No preservatives</li>
                  <li>Vegetarian & clean-label</li>
                  <li>3-minute crisp solution*</li>
                </ul>
              </div>
              {/* <button className="smiproductt-btn">Enquire Now</button> */}
            </div>
          </div>
        </div>
      </section>
      {/* ✅ styled-jsx CSS inside component */}
      <style jsx>{`

        .smiproductt-section {
          padding: 20px 20px;
        }
        .smiproductt-card {
          background: #fff;
          border-radius: 15px;
          box-shadow: 0 6px 6px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .smiproductt-card:hover {
          // transform: translateY(-6px);
          // box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
        }
        .smiproductt-img {
          width: 100%;
          height: auto;
          border-radius: 12px;
          transition: transform 0.3s ease;
        }
        .smiproductt-img:hover {
          transform: scale(1.05);
        }
        .smiproductt-title {
          font-size: 1.9rem;
          font-weight: 700;
          color: #f0b323;
          margin-bottom: 10px;
        }
        .smiproductt-subtitle {
          font-size: 1.5rem;
          font-weight: 600;
          color: #0f1138;
          margin-bottom: 20px;
        }
        .smiproductt-text {
          font-size: 1rem;
          color: #555;
          margin-bottom: 20px;
        }
        .smiproductt-meta {
          background: #f0b3231c;
          border-left: 5px solid #f0b323;
          padding: 15px 20px;
          border-radius: 8px;
          font-size: 0.95rem;
          margin-bottom: 20px;
        }
        .smiproductt-meta ul {
          margin: 0;
          padding-left: 18px;
        }
        .smiproductt-btn {
          background: #e67e22;
          border: none;
          color: #fff;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 8px;
          transition: background 0.3s ease;
        }
        .smiproductt-btn:hover {
          background: #d35400;
          color: #fff;
        }
        @media (max-width: 767px) {
          .smiproductt-title {
            font-size: 1.6rem;
          }
          .smiproductt-subtitle {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Frenchfries_comp;
